import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
//import { useMsal } from "@azure/msal-react";
//import { getDetails } from "../../../../utils/msal-utils"; // handleLoginRedirect,acquireTokenSilent,
import { setLoginAudit, showLoader } from "../../../../utils/msal-utils";
import "./login.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn, faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import NewFeatureAnnouncement from "../../ProfileLanding/newFeatureAnnouncement";
import { Dialog } from "primereact/dialog";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string, InferType, ref } from "yup";
import { useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom"; //useLocation
import { useDispatch, useSelector } from "react-redux";
import { sendMail, selectDetails } from "./forgotPasswordSlice";
import { nonSSOLogin, selectNonSSOLoginDetails } from "./nonSSOLoginSlice";
import {
  classifyIdentifier,
  selectClassifyDetails,
  resetClassify,
} from "./classifyIdentifierSlice";
import { OTPVerification } from "./otpVerification";
import DotGlobe from "./DotGlobe";
import ttecWhiteLogo from "../../../../images/TTEC Standalone Logo - White.svg";
import {
  genOTPandSaveUser,
  selectOTPandUserDetails,
} from "./genOTPandSaveUserSlice";
import Spinner from "../../../../utils/spinner";
import { BASE_URL } from "../../../../utils/CONSTANTS";
import axios from "axios";

const signInSchema = object({
  signinEmail: string()
    .email("Enter a valid Email address")
    .required("Please enter the Email"),
  password: string()
    .required("Please enter the Password")
    .matches(/(?=.*?[A-Z])/, "Please enter atleast one Uppercase")
    .matches(/(?=.*?[a-z])/, "Please enter atleast one Lowercase")
    .matches(/(?=.*?[0-9])/, "Please enter atleast one digit")
    .matches(
      /(?=.*?[#?!@$%^&*-])/,
      "Please enter atleast one Special Character"
    )
    .matches(/.{8,}/, "Please enter minumum 8 characters"),
});

const forgotPwdSchema = object({
  forgotPwdEmail: string()
    .email("Enter a valid Email address")
    .required("Please enter the Email"),
});

const signUpSchema = object({
  signUpEmail: string()
    .email("Enter a valid Email address")
    .required("Please enter the Email"),
  verifyemail: string()
    .email("Enter a valid Email address")
    .required("Please re-enter the email to verify")
    .oneOf([ref("signUpEmail")], "Email does not match"),
  signUpPassword: string()
    .required("Please enter password")
    .matches(/(?=.*?[A-Z])/, "Please enter atleast one Uppercase")
    .matches(/(?=.*?[a-z])/, "Please enter atleast one Lowercase")
    .matches(/(?=.*?[0-9])/, "Please enter atleast one digit")
    .matches(
      /(?=.*?[#?!@$%^&*-])/,
      "Please enter atleast one Special Character"
    )
    .matches(/.{8,}/, "Please enter minumum 8 characters"),
  verifypassword: string()
    .required("Please re-enter password to verify")
    .oneOf([ref("signUpPassword")], "Password does not match"),
  mobileNumber: string()
    .required("Please enter the Mobile Number")
    .typeError("Mobile Number must be a number")
    .min(7, "Please provide a valid phone number"),
  otpCode: string()
    // .required("Please enter the OTP sent to your phone number.")
    .max(6, "The maximum length is 6")
    .min(6, "The minimum length is 6"),
  countryCode: string().required("Please select the country code"),
});

type signInProps = InferType<typeof signInSchema>;
type signUpProps = InferType<typeof signUpSchema>;
type forgotPwdProps = InferType<typeof forgotPwdSchema>;
type signInMobileProps = InferType<typeof signInSchema>;
type signUpMobileProps = InferType<typeof signUpSchema>;
type forgotPwdMobileProps = InferType<typeof forgotPwdSchema>;

const Login = (props: any) => {
  let { id } = useParams();
  //const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const { status, state } = useSelector(selectDetails);
  const [isForgotPwd, setisForgotPwd] = useState(false);
  const [fpMail, setfpMail] = useState("");
  const [mail, setLoginMail] = useState("");
  const [password, setLoginPassword] = useState("");
  const [mailStatus, setmailStatus] = useState(status);
  const { nonSSOStatus, nonSSOState, nonSSOReqType, nonSSOMsg } = useSelector(
    selectNonSSOLoginDetails
  );
  const { emp_uid, otpstate, otpstatus, regrequestType } = useSelector(
    selectOTPandUserDetails
  );
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [userCountryCode, setUserCountryCode] = useState("");
  const [userPersonalEmail, setUserPersonalEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userEmp_uid, setUserEmpUid] = useState(emp_uid);
  const [emailStatus, setemailStatus] = useState(otpstatus);
  const [isFirstFPCall, setIsFirstFPCall] = useState(false);
  const [isFirstLoginCall, setIsFirstLoginCall] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [path] = useState(process.env.REACT_APP_RESET_PASSWORD_URL);
  // const { state: locationState } = useLocation();
  const [redirectSSO, setRedirectSSO] = useState(false);
  // Unified email-first entry state machine (additive; existing state kept for reuse)
  const [authStep, setAuthStep] = useState<
    "identifier" | "password" | "register"
  >("identifier");
  const [identifierEmail, setIdentifierEmail] = useState("");
  const [identifierError, setIdentifierError] = useState("");
  const { route, classifyState, classifyError } = useSelector(
    selectClassifyDetails
  );
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const [showRgPass, setShowRgPass] = useState(false);
  const [showLoginPass, setShowLoginPass] = useState(false);
  const [rgStrength, setRgStrength] = useState(0);
  const calcStrength = (v: string) => {
    let s = 0;
    if (v.length >= 8) s++;
    if (/[A-Z]/.test(v) && /[a-z]/.test(v)) s++;
    if (/[0-9]/.test(v)) s++;
    if (/[#?!@$%^&*-]/.test(v)) s++;
    return s;
  };

  const {
    register: signInRegister,
    handleSubmit: signInHandle,
    formState: { errors: signInErrors },
    reset: signInReset,
    setValue: signInSetValue,
  } = useForm<signInProps>({
    resolver: yupResolver(signInSchema),
  });
  const {
    register: signInMobileRegister,
    handleSubmit: signInMobileHandle,
    formState: { errors: signInMobileErrors },
    reset: signInMobileReset,
    setValue: signInMobileSetValue,
  } = useForm<signInMobileProps>({
    resolver: yupResolver(signInSchema),
  });
  const {
    register: signUpRegister,
    handleSubmit: signUpHandle,
    formState: { errors: signUpErrors },
    reset: signUpReset,
    setValue: signUpSetValue,
  } = useForm<signUpProps>({
    resolver: yupResolver(signUpSchema),
  });
  const {
    register: signUpMobileRegister,
    handleSubmit: signUpMobileHandle,
    formState: { errors: signUpMobileErrors },
    reset: signUpMobileReset,
    setValue: signUpMobileSetValue,
  } = useForm<signUpMobileProps>({
    resolver: yupResolver(signUpSchema),
  });
  const {
    register: forgotPwdRegister,
    handleSubmit: forgotPwdHandle,
    formState: { errors: forgotPwdErrors },
    reset: forgotPwdReset,
    setValue: forgotPwdSetValue,
  } = useForm<forgotPwdProps>({
    resolver: yupResolver(forgotPwdSchema),
  });
  const {
    register: forgotPwdMobileRegister,
    handleSubmit: forgotPwdMobileHandle,
    formState: { errors: forgotPwdMobileErrors },
    reset: forgotPwdMobileReset,
    setValue: forgotPwdMobileSetValue,
  } = useForm<forgotPwdMobileProps>({
    resolver: yupResolver(forgotPwdSchema),
  });
  function handleForgotPassword() {
    setisForgotPwd(true);
    signInReset();
    signInMobileReset();
    forgotPwdReset();
    forgotPwdMobileReset();
    // Carry the email entered on the identifier step into the reset flow.
    const carriedEmail = identifierEmail.trim();
    setfpMail(carriedEmail);
    if (carriedEmail) {
      forgotPwdSetValue("forgotPwdEmail", carriedEmail);
      forgotPwdMobileSetValue("forgotPwdEmail", carriedEmail);
    }
    setLoginMail("");
    setLoginPassword("");
    setmailStatus("");
    setIsFirstFPCall(true);
    setIsFirstLoginCall(false);
  }

  function handleBackSignIn() {
    setisForgotPwd(false);
    signInReset();
    signInMobileReset();
    forgotPwdReset();
    forgotPwdMobileReset();
    setmailStatus("");
    setfpMail("");
    setIsFirstFPCall(false);
    setIsFirstLoginCall(true);
    signUpReset();
    signUpMobileReset();
  }

  function handleForgetPassword() {
    setIsFirstFPCall(false);

    let data = {
      request: {
        action: "ForgotPassword",
        personalEmailAddress: fpMail,
        path: path,
      },
    };

    if (fpMail !== "") {
      dispatch<any>(sendMail(data));
    }
  }

  const handleSignUp = () => {
    setIsLogin(false);
    const data = {
      input: {
        request: {
          action: "ValidateNewUser",
          personalEmailAddress: userPersonalEmail,
          phoneNumber: (userCountryCode + userPhoneNumber).split(" ").join(""),
          subAction: "SignUp",
        },
      },
      requestType: {
        type: "genOtp",
      },
    };
    if (
      userPersonalEmail !== "" &&
      userPhoneNumber !== "" &&
      emailStatus !== "200"
    ) {
      dispatch<any>(genOTPandSaveUser(data));
    }
    setemailStatus(otpstatus);
  };

  // useEffect(() => {
  //   if (accounts.length > 0) {
  //     acquireTokenSilent(instance, accounts, false);
  //   }
  // });

  useEffect(() => {
    setmailStatus(status);
  }, [status]);

  useEffect(() => {
    setemailStatus(otpstatus);
  }, [otpstatus]);

  useEffect(() => {
    setUserEmpUid(emp_uid);
  }, [emp_uid]);

  function handleSSOLogin() {
    setRedirectSSO(true);
    window.location.href = BASE_URL + "api/login";
  }

  // --- Unified email-first entry ---------------------------------------------
  const handleContinue = () => {
    // Guard: ignore rapid repeat submits (Enter-key spam) while a classify is in flight.
    if (classifyState === "pending") return;
    const email = identifierEmail.trim();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setIdentifierError("Enter a valid Email address");
      return;
    }
    setIdentifierError("");
    dispatch<any>(classifyIdentifier(email));
  };

  const handleChangeIdentifier = () => {
    dispatch<any>(resetClassify());
    setAuthStep("identifier");
    setisForgotPwd(false);
    signInReset();
    signUpReset();
    signInMobileReset();
    signUpMobileReset();
    setLoginMail("");
    setLoginPassword("");
    setIdentifierError("");
  };

  // Go to Register carrying the identifier email into the sign-up fields (blank if none).
  const goToRegister = () => {
    const carried = identifierEmail.trim();
    setUserPersonalEmail(carried);
    signUpSetValue("signUpEmail", carried);
    signUpMobileSetValue("signUpEmail", carried);
    signUpSetValue("verifyemail", carried);
    signUpMobileSetValue("verifyemail", carried);
    setAuthStep("register");
  };

  // React to classify result: route to SSO / password / register.
  useEffect(() => {
    if (classifyState !== "fulfilled") return;
    const email = identifierEmail.trim();
    if (route === "sso") {
      handleSSOLogin();
    } else if (route === "password") {
      setLoginMail(email);
      signInSetValue("signinEmail", email);
      signInMobileSetValue("signinEmail", email);
      setAuthStep("password");
    } else if (route === "register") {
      setUserPersonalEmail(email);
      signUpSetValue("signUpEmail", email);
      signUpMobileSetValue("signUpEmail", email);
      signUpSetValue("verifyemail", email);
      signUpMobileSetValue("verifyemail", email);
      setAuthStep("register");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classifyState, route]);

  const navigate = useNavigate();

  useEffect(() => {
    const getDetails = async (id: any) => {
      // alert(id);
      const headers = {
        "Content-Type": "application/json",
      };
      if (
        id !== undefined &&
        id !== null &&
        id !== ":id" &&
        (localStorage.getItem("AccessToken") === null ||
          localStorage.getItem("AccessToken") === undefined)
      ) {
        const res = await new Promise((resolve, reject) => {
          showLoader();
          try {
            axios
              .get(BASE_URL + "api/getdetails?id=" + id, { headers: headers })
              .then((res: any) => {
                resolve(res);
              })
              .catch((err) => {
                resolve(err);
              });
          } catch (error) {
            reject(error);
          }
        });
        if ((res as any)?.data?.httpStatus === 200) {
          //navigate(LOAD);
          localStorage.setItem(
            "AccessToken",
            "Bearer " + (res as any)?.data?.data?.accessToken
          );
          localStorage.setItem(
            "RefreshToken",
            (res as any)?.data?.data?.refreshToken
          );
          // Store IdToken — PingOne returns user identity claims (email, name, etc.) here,
          // not in the access token. setLoginAudit and any UI personalization should read from this.
          if ((res as any)?.data?.data?.idToken) {
            localStorage.setItem(
              "IdToken",
              (res as any).data.data.idToken
            );
          }

          await setLoginAudit(
            "Bearer " + (res as any)?.data?.data?.accessToken + "",
            "Login"
          );
          //  window.location.reload();
        }
      } /* else {
      navigate("../../../shared-components/initialLoadPage");
    } */
    };

    getDetails(id);
  }, [id, navigate]);
  // useEffect(() => {
  //   if (locationState && instance) {
  //     handleSSOLogin();
  //     setRedirectSSO(true);
  //   }
  // }, [instance, locationState, accounts]);

  const navRef = useRef<HTMLHeadingElement>(null);

  // const onToggleClick = () => {
  //   document.getElementsByClassName("cont")[0].classList.toggle("s--signup");
  //   signInReset();
  //   signInMobileReset();
  //   signUpMobileReset();
  //   forgotPwdReset();
  //   forgotPwdMobileReset();
  //   setemailStatus(null);
  //   setIsLogin(!isLogin);
  //   setIsFirstLoginCall(true);
  // };

  const handleNonSSOLogin = async () => {
    setIsFirstLoginCall(false);
    const data = {
      input: {
        username: mail,
        password: password,
        otp: "",
        subAction: "login",
      },
      nonSSOReqType: {
        type: "login",
      },
    };
    dispatch<any>(nonSSOLogin(data));
  };

  useEffect(() => {
    if (props.isForgotPwd) {
      setisForgotPwd(props.isForgotPwd);
    }
  }, [props.isForgotPwd]);

  return (
    <>
      {redirectSSO === true && <Spinner />}
      <Dialog
        header="Get to Know TTEC Connect"
        visible={videoModalOpen}
        onHide={() => setVideoModalOpen(false)}
        style={{ width: "min(760px, 92vw)" }}
        modal
        dismissableMask
      >
        <div style={{ position: "relative", paddingTop: "56.25%" }}>
          {videoModalOpen && (
            <iframe
              src="https://fast.wistia.net/embed/iframe/9r0028dduh?autoplay=1"
              title="TTEConnect Video"
              allow="autoplay; fullscreen"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0,
                borderRadius: 12,
              }}
            />
          )}
        </div>
      </Dialog>
      <div id="loginMobile">
        <div className="mobileCrest">
          <div className="brandGrid" />
          <DotGlobe className="mobileCrestGlobe" size={300} variant="bright" />
          <div className="mobileCrestContent">
            <div className="mobileCrestLockup">
              <img
                src={ttecWhiteLogo}
                className="mobileCrestLogo"
                alt="TTEC Connect"
              />
            </div>
            <h2 className="brandTitle">
              Your first day,
              <br />
              <em>already in motion.</em>
            </h2>
            <p className="brandTagline">
              Everything a new hire needs — onboarding and your team — in one
              place. Sign in to pick up where you left off.
            </p>
          </div>
        </div>
        {((isLogin &&
          nonSSOReqType === "" &&
          nonSSOState !== "fulfilled" &&
          nonSSOStatus !== "success") ||
          (!isLogin && otpstatus !== "200")) && (
            <main className="form-signin pt-5">
              <div className="container">
                {authStep === "identifier" && !isForgotPwd && (
                  <div className="loginContainer">
                    <div className="eyebrow">Welcome</div>
                    <h1 className="authH1">Sign in to TTEC&nbsp;Connect</h1>
                    <p className="sub">
                      Enter your email and we&apos;ll take you to the right
                      sign-in method — no need to choose an account type.
                    </p>
                    <form
                      className="Auth-form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleContinue();
                      }}
                    >
                      <div className="field">
                        <input
                          id="mFloatingIdentifier"
                          type="email"
                          placeholder=" "
                          value={identifierEmail}
                          onChange={(e) =>
                            setIdentifierEmail(e.currentTarget.value)
                          }
                        />
                        <label htmlFor="mFloatingIdentifier">
                          Email address <span className="req">*</span>
                        </label>
                      </div>
                      <p className="hint">
                        Use the same personal email you provided to TTEC during
                        your application.
                      </p>
                      {identifierError !== "" && (
                        <p className="frmErrors mt-2">{identifierError}</p>
                      )}
                      {classifyState === "fulfilled" &&
                        classifyError === "unrecognized" && (
                          <p className="frmErrors mt-2">
                            We couldn't find an account for that email. Check the
                            address, or create an account.
                          </p>
                        )}
                      {classifyState === "failed" && (
                        <p className="frmErrors mt-2">
                          We couldn't reach the sign-in service. Please try again
                          in a moment.
                        </p>
                      )}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={classifyState === "pending"}
                      >
                        Continue
                      </button>
                    </form>
                    <p className="foot">
                      <a
                        href="/docs/TTEConnect Login Process.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Having issues logging in?
                      </a>
                    </p>
                  </div>
                )}
                {authStep === "password" && (
                  <div className="loginContainer" id="signInContainer">
                    {!isForgotPwd && (
                      <form
                        className="Auth-form"
                        onSubmit={signInMobileHandle(handleNonSSOLogin)}
                      >
                        <div className="eyebrow">Welcome back</div>
                        <h1 className="authH1">Enter your password</h1>
                        {!isFirstLoginCall &&
                          nonSSOStatus !== "success" &&
                          nonSSOState === "failed" && (
                            <div className="alert err">{nonSSOMsg}</div>
                          )}
                        <div className="emailChip">
                          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                            <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                          </svg>
                          <span className="emailChipValue">{identifierEmail}</span>
                          <Link to="" onClick={handleChangeIdentifier}>
                            Change
                          </Link>
                        </div>
                        <input
                          type="hidden"
                          {...signInMobileRegister("signinEmail")}
                        />
                        <div className="field hasIcon">
                          <input
                            id="mFloatingPassword"
                            type={showLoginPass ? "text" : "password"}
                            placeholder=" "
                            {...signInMobileRegister("password")}
                            onKeyUp={(event) =>
                              setLoginPassword(event.currentTarget.value)
                            }
                          />
                          <label htmlFor="mFloatingPassword">
                            Password <span className="req">*</span>
                          </label>
                          <button
                            type="button"
                            className="icon"
                            aria-label="Show password"
                            onClick={() => setShowLoginPass((s) => !s)}
                          >
                            <svg viewBox="0 0 24 24" fill="none">
                              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="2" />
                              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                            </svg>
                          </button>
                        </div>
                        {signInMobileErrors?.password && (
                          <p className="frmErrors mt-2">
                            {signInMobileErrors?.password?.message}
                          </p>
                        )}
                        <div className="rowbetween">
                          <Link to="" onClick={handleForgotPassword}>
                            Forgot password?
                          </Link>
                        </div>
                        <button
                          disabled={nonSSOState === "pending" ? true : false}
                          className="btn btn-primary"
                          type="submit"
                        >
                          Sign in
                        </button>
                        <p className="foot">
                          New to TTEC Connect?{" "}
                          <Link to="" onClick={goToRegister}>
                            Create an account
                          </Link>
                        </p>
                      </form>
                    )}
                    {isForgotPwd && (
                      <form className="Auth-form">
                        <div className="recoveryTopRow">
                          <span className="backlink" onClick={handleBackSignIn}>
                            <svg viewBox="0 0 24 24" fill="none">
                              <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Back to sign in
                          </span>
                          <div className="eyebrow">Account recovery</div>
                        </div>
                        <h1 className="authH1">Reset your password</h1>
                        <p className="sub">
                          Enter your email and we&apos;ll send you a link to set a
                          new password.
                        </p>
                        {!isFirstFPCall &&
                          mailStatus !== "200" &&
                          fpMail !== "" &&
                          (state === "fulfilled" || state === "failed") && (
                            <div className="alert err">
                              Please enter the valid email
                            </div>
                          )}
                        {mailStatus === "200" && (
                          <div className="alert ok">
                            Your password reset email has been sent. If you
                            don&apos;t receive it please wait a few minutes and
                            try again.
                          </div>
                        )}
                        {mailStatus !== "200" &&
                          (identifierEmail ? (
                            <>
                              <input
                                type="hidden"
                                {...forgotPwdMobileRegister("forgotPwdEmail")}
                              />
                              <div className="emailChip">
                                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                                  <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                                </svg>
                                <span className="emailChipValue">
                                  {identifierEmail}
                                </span>
                                <Link to="" onClick={handleChangeIdentifier}>
                                  Change
                                </Link>
                              </div>
                            </>
                          ) : (
                            <div className="field">
                              <input
                                id="mFgEmail"
                                type="email"
                                placeholder=" "
                                {...forgotPwdMobileRegister("forgotPwdEmail")}
                                onChange={(event) => setfpMail(event.target.value)}
                              />
                              <label htmlFor="mFgEmail">
                                Email address <span className="req">*</span>
                              </label>
                            </div>
                          ))}
                        {forgotPwdMobileErrors?.forgotPwdEmail && (
                          <p className="frmErrors mt-2">
                            {forgotPwdMobileErrors?.forgotPwdEmail?.message}
                          </p>
                        )}
                        {mailStatus !== "200" && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={forgotPwdMobileHandle(handleForgetPassword)}
                          >
                            Send reset link
                          </button>
                        )}
                      </form>
                    )}
                  </div>
                )}

                {authStep === "register" &&
                  emailStatus !== "200" &&
                  nonSSOReqType === "" &&
                  nonSSOState !== "fulfilled" &&
                  nonSSOStatus !== "success" &&
                  otpstatus !== "200" && (
                    <div className="loginContainer" id="signUpContainer">
                      <form
                        className="Auth-form-sub"
                        onSubmit={signUpMobileHandle(handleSignUp)}
                      >
                        <span className="backlink" onClick={handleChangeIdentifier}>
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Back to sign in
                        </span>
                        <div className="stepper">
                          <div className="st active">
                            <span className="dot">1</span>Account
                          </div>
                          <span className="bar"></span>
                          <div className="st">
                            <span className="dot">2</span>Verify
                          </div>
                        </div>
                        <h1 className="authH1">Create your account</h1>
                        <p className="sub">
                          Use the same personal email you provided to TTEC during
                          your application.
                        </p>
                        {emailStatus === "302" && otpstate !== "pending" && (
                          <div className="alert err">
                            Invalid or already registered email.
                          </div>
                        )}
                        <div className="field">
                          <input
                            id="mRgEmail"
                            type="email"
                            placeholder=" "
                            {...signUpMobileRegister("signUpEmail")}
                            onChange={(event) =>
                              setUserPersonalEmail(event.target.value)
                            }
                          />
                          <label htmlFor="mRgEmail">
                            Email address <span className="req">*</span>
                          </label>
                        </div>
                        <p className="frmErrors mt-2">
                          {(emailStatus === "400" &&
                            otpstate !== "pending" &&
                            "Invalid or already registered email.") ||
                            (signUpMobileErrors?.signUpEmail &&
                              signUpMobileErrors?.signUpEmail?.message)}
                        </p>
                        {emailStatus !== "200" && (
                          <div className="field">
                            <input
                              id="mRgEmail2"
                              type="email"
                              placeholder=" "
                              {...signUpMobileRegister("verifyemail")}
                            />
                            <label htmlFor="mRgEmail2">
                              Verify email address <span className="req">*</span>
                            </label>
                          </div>
                        )}
                        {signUpMobileErrors?.verifyemail && (
                          <p className="frmErrors mt-2">
                            {signUpMobileErrors?.verifyemail?.message}
                          </p>
                        )}
                        <div className="field hasIcon">
                          <input
                            id="mRgPass"
                            type={showRgPass ? "text" : "password"}
                            placeholder=" "
                            {...signUpMobileRegister("signUpPassword")}
                            onChange={(event) => {
                              setUserPassword(event.target.value);
                              setRgStrength(calcStrength(event.target.value));
                            }}
                          />
                          <label htmlFor="mRgPass">
                            Password <span className="req">*</span>
                          </label>
                          <button
                            type="button"
                            className="icon"
                            aria-label="Show password"
                            onClick={() => setShowRgPass((s) => !s)}
                          >
                            <svg viewBox="0 0 24 24" fill="none">
                              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="2" />
                              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                            </svg>
                          </button>
                        </div>
                        <div className="meter">
                          {[1, 2, 3, 4].map((n) => (
                            <i
                              key={n}
                              className={n <= rgStrength ? "on" + rgStrength : ""}
                            />
                          ))}
                        </div>
                        <div className="meter-label">
                          <span>8+ chars · upper · lower · number · symbol</span>
                          <span>
                            {["", "Weak", "Fair", "Good", "Strong"][rgStrength]}
                          </span>
                        </div>
                        {signUpMobileErrors?.signUpPassword && (
                          <p className="frmErrors mt-2">
                            {signUpMobileErrors?.signUpPassword?.message}
                          </p>
                        )}
                        <div className="field">
                          <input
                            id="mRgPass2"
                            type="password"
                            placeholder=" "
                            {...signUpMobileRegister("verifypassword")}
                          />
                          <label htmlFor="mRgPass2">
                            Verify password <span className="req">*</span>
                          </label>
                        </div>
                        {signUpMobileErrors?.verifypassword && (
                          <p className="frmErrors mt-2">
                            {signUpMobileErrors?.verifypassword?.message}
                          </p>
                        )}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "130px 1fr",
                            gap: "11px",
                          }}
                        >
                          <div className="field">
                              <select
                                id="mRgCc"
                                className="filled"
                                {...signUpMobileRegister("countryCode")}
                                onChange={(event) =>
                                  setUserCountryCode(event.target.value)
                                }
                              >
                                <option value=""></option>
                                <option value="+376">AD (+376)</option>
                                <option value="+971">AE (+971)</option>
                                <option value="+1268">AG (+1268)</option>
                                <option value="+1264">AI (+1264)</option>
                                <option value="+374">AM (+374)</option>
                                <option value="+244">AO (+244)</option>
                                <option value="+54">AR (+54)</option>
                                <option value="+43">AT (+43)</option>
                                <option value="+61">AU (+61)</option>
                                <option value="+297">AW (+297)</option>
                                <option value="+994">AZ (+994)</option>
                                <option value="+387">BA (+387)</option>
                                <option value="+1246">BB (+1246)</option>
                                <option value="+880">BD (+880)</option>
                                <option value="+32">BE (+32)</option>
                                <option value="+226">BF (+226)</option>
                                <option value="+359">BG (+359)</option>
                                <option value="+973">BH (+973)</option>
                                <option value="+257">BI (+257)</option>
                                <option value="+229">BJ (+229)</option>
                                <option value="+1441">BM (+1441)</option>
                                <option value="+673">BN (+673)</option>
                                <option value="+591">BO (+591)</option>
                                <option value="+55">BR (+55)</option>
                                <option value="+1242">BS (+1242)</option>
                                <option value="+975">BT (+975)</option>
                                <option value="+267">BW (+267)</option>
                                <option value="+375">BY (+375)</option>
                                <option value="+501">BZ (+501)</option>
                                <option value="+1">CA (+1)</option>
                                <option value="+236">CF (+236)</option>
                                <option value="+242">CG (+242)</option>
                                <option value="+41">CH (+41)</option>
                                <option value="+682">CK (+682)</option>
                                <option value="+56">CL (+56)</option>
                                <option value="+237">CM (+237)</option>
                                <option value="+86">CN (+86)</option>
                                <option value="+57">CO (+57)</option>
                                <option value="+506">CR (+506)</option>
                                <option value="+381">CS (+381)</option>
                                <option value="+53">CU (+53)</option>
                                <option value="+238">CV (+238)</option>
                                <option value="+357">CY (+357)</option>
                                <option value="+9039">CY (+9039)</option>
                                <option value="+42">CZ (+42)</option>
                                <option value="+49">DE (+49)</option>
                                <option value="+253">DJ (+253)</option>
                                <option value="+45">DK (+45)</option>
                                <option value="+1809">DM (+1809)</option>
                                <option value="+1809">DO (+1809)</option>
                                <option value="+213">DZ (+213)</option>
                                <option value="+593">EC (+593)</option>
                                <option value="+372">EE (+372)</option>
                                <option value="+20">EG (+20)</option>
                                <option value="+291">ER (+291)</option>
                                <option value="+34">ES (+34)</option>
                                <option value="+251">ET (+251)</option>
                                <option value="+358">FI (+358)</option>
                                <option value="+679">FJ (+679)</option>
                                <option value="+500">FK (+500)</option>
                                <option value="+691">FM (+691)</option>
                                <option value="+298">FO (+298)</option>
                                <option value="+33">FR (+33)</option>
                                <option value="+241">GA (+241)</option>
                                <option value="+44">GB (+44)</option>
                                <option value="+1473">GD (+1473)</option>
                                <option value="+7880">GE (+7880)</option>
                                <option value="+594">GF (+594)</option>
                                <option value="+233">GH (+233)</option>
                                <option value="+350">GI (+350)</option>
                                <option value="+299">GL (+299)</option>
                                <option value="+220">GM (+220)</option>
                                <option value="+224">GN (+224)</option>
                                <option value="+590">GP (+590)</option>
                                <option value="+240">GQ (+240)</option>
                                <option value="+30">GR (+30)</option>
                                <option value="+502">GT (+502)</option>
                                <option value="+671">GU (+671)</option>
                                <option value="+245">GW (+245)</option>
                                <option value="+592">GY (+592)</option>
                                <option value="+852">HK (+852)</option>
                                <option value="+504">HN (+504)</option>
                                <option value="+385">HR (+385)</option>
                                <option value="+509">HT (+509)</option>
                                <option value="+36">HU (+36)</option>
                                <option value="+62">ID (+62)</option>
                                <option value="+353">IE (+353)</option>
                                <option value="+972">IL (+972)</option>
                                <option value="+91">IN (+91)</option>
                                <option value="+964">IQ (+964)</option>
                                <option value="+98">IR (+98)</option>
                                <option value="+354">IS (+354)</option>
                                <option value="+39">IT (+39)</option>
                                <option value="+1876">JM (+1876)</option>
                                <option value="+962">JO (+962)</option>
                                <option value="+81">JP (+81)</option>
                                <option value="+254">KE (+254)</option>
                                <option value="+996">KG (+996)</option>
                                <option value="+855">KH (+855)</option>
                                <option value="+686">KI (+686)</option>
                                <option value="+269">KM (+269)</option>
                                <option value="+1869">KN (+1869)</option>
                                <option value="+850">KP (+850)</option>
                                <option value="+82">KR (+82)</option>
                                <option value="+965">KW (+965)</option>
                                <option value="+1345">KY (+1345)</option>
                                <option value="+7">KZ (+7)</option>
                                <option value="+856">LA (+856)</option>
                                <option value="+961">LB (+961)</option>
                                <option value="+417">LI (+417)</option>
                                <option value="+94">LK (+94)</option>
                                <option value="+231">LR (+231)</option>
                                <option value="+266">LS (+266)</option>
                                <option value="+370">LT (+370)</option>
                                <option value="+352">LU (+352)</option>
                                <option value="+371">LV (+371)</option>
                                <option value="+218">LY (+218)</option>
                                <option value="+212">MA (+212)</option>
                                <option value="+377">MC (+377)</option>
                                <option value="+373">MD (+373)</option>
                                <option value="+261">MG (+261)</option>
                                <option value="+692">MH (+692)</option>
                                <option value="+389">MK (+389)</option>
                                <option value="+223">ML (+223)</option>
                                <option value="+95">MN (+95)</option>
                                <option value="+976">MN (+976)</option>
                                <option value="+853">MO (+853)</option>
                                <option value="+596">MQ (+596)</option>
                                <option value="+222">MR (+222)</option>
                                <option value="+1664">MS (+1664)</option>
                                <option value="+356">MT (+356)</option>
                                <option value="+960">MV (+960)</option>
                                <option value="+265">MW (+265)</option>
                                <option value="+52">MX (+52)</option>
                                <option value="+60">MY (+60)</option>
                                <option value="+258">MZ (+258)</option>
                                <option value="+264">NA (+264)</option>
                                <option value="+687">NC (+687)</option>
                                <option value="+227">NE (+227)</option>
                                <option value="+672">NF (+672)</option>
                                <option value="+234">NG (+234)</option>
                                <option value="+505">NI (+505)</option>
                                <option value="+31">NL (+31)</option>
                                <option value="+47">NO (+47)</option>
                                <option value="+670">NP (+670)</option>
                                <option value="+977">NP (+977)</option>
                                <option value="+674">NR (+674)</option>
                                <option value="+683">NU (+683)</option>
                                <option value="+64">NZ (+64)</option>
                                <option value="+968">OM (+968)</option>
                                <option value="+507">PA (+507)</option>
                                <option value="+51">PE (+51)</option>
                                <option value="+689">PF (+689)</option>
                                <option value="+675">PG (+675)</option>
                                <option value="+63">PH (+63)</option>
                                <option value="+48">PL (+48)</option>
                                <option value="+1787">PR (+1787)</option>
                                <option value="+351">PT (+351)</option>
                                <option value="+680">PW (+680)</option>
                                <option value="+595">PY (+595)</option>
                                <option value="+974">QA (+974)</option>
                                <option value="+262">RE (+262)</option>
                                <option value="+40">RO (+40)</option>
                                <option value="+7">RU (+7)</option>
                                <option value="+250">RW (+250)</option>
                                <option value="+966">SA (+966)</option>
                                <option value="+677">SB (+677)</option>
                                <option value="+1758">SC (+1758)</option>
                                <option value="+248">SC (+248)</option>
                                <option value="+249">SD (+249)</option>
                                <option value="+46">SE (+46)</option>
                                <option value="+65">SG (+65)</option>
                                <option value="+290">SH (+290)</option>
                                <option value="+386">SI (+386)</option>
                                <option value="+963">SI (+963)</option>
                                <option value="+421">SK (+421)</option>
                                <option value="+232">SL (+232)</option>
                                <option value="+378">SM (+378)</option>
                                <option value="+221">SN (+221)</option>
                                <option value="+252">SO (+252)</option>
                                <option value="+597">SR (+597)</option>
                                <option value="+239">ST (+239)</option>
                                <option value="+503">SV (+503)</option>
                                <option value="+268">SZ (+268)</option>
                                <option value="+1649">TC (+1649)</option>
                                <option value="+228">TG (+228)</option>
                                <option value="+66">TH (+66)</option>
                                <option value="+7">TJ (+7)</option>
                                <option value="+7">TM (+7)</option>
                                <option value="+993">TM (+993)</option>
                                <option value="+216">TN (+216)</option>
                                <option value="+676">TO (+676)</option>
                                <option value="+90">TR (+90)</option>
                                <option value="+1868">TT (+1868)</option>
                                <option value="+688">TV (+688)</option>
                                <option value="+886">TW (+886)</option>
                                <option value="+380">UA (+380)</option>
                                <option value="+256">UG (+256)</option>
                                <option value="+1">US (+1)</option>
                                <option value="+598">UY (+598)</option>
                                <option value="+7">UZ (+7)</option>
                                <option value="+379">VA (+379)</option>
                                <option value="+58">VE (+58)</option>
                                <option value="+1284">VG (+1284)</option>
                                <option value="+1340">VI (+1340)</option>
                                <option value="+84">VN (+84)</option>
                                <option value="+678">VU (+678)</option>
                                <option value="+681">WF (+681)</option>
                                <option value="+967">YE (+967)</option>
                                <option value="+969">YE (+969)</option>
                                <option value="+269">YT (+269)</option>
                                <option value="+27">ZA (+27)</option>
                                <option value="+260">ZM (+260)</option>
                                <option value="+263">ZW (+263)</option>
                              </select>
                              <label htmlFor="mRgCc">
                                Code <span className="req">*</span>
                              </label>
                          </div>
                          <div className="field">
                            <input
                              id="mRgPhone"
                              type="tel"
                              placeholder=" "
                              {...signUpMobileRegister("mobileNumber")}
                              onChange={(event) =>
                                setUserPhoneNumber(event.target.value)
                              }
                              onInput={(e) =>
                              (e.currentTarget.value =
                                e.currentTarget.value.slice(0, 15))
                              }
                            />
                            <label htmlFor="mRgPhone">
                              Phone number <span className="req">*</span>
                            </label>
                          </div>
                        </div>
                        <p className="hint">
                          We&apos;ll text a 6-digit verification code to this
                          number.
                        </p>
                        {signUpMobileErrors?.countryCode && (
                          <p className="frmErrors mt-2">
                            {signUpMobileErrors?.countryCode?.message}
                          </p>
                        )}
                        {signUpMobileErrors?.mobileNumber && (
                          <p className="frmErrors mt-2">
                            {signUpMobileErrors?.mobileNumber?.message}
                          </p>
                        )}
                        {emailStatus !== "200" && (
                          <button
                            type="submit"
                            disabled={otpstate === "pending" ? true : false}
                            className="btn btn-primary"
                          >
                            Create account
                          </button>
                        )}
                        {/* <p className="foot">© 2025 TTEC, All rights reserved.</p> */}
                      </form>
                    </div>
                  )}
              </div>
            </main>
          )}
        {regrequestType === "genOtp" && otpstatus === "200" && userEmp_uid && (
          <OTPVerification
            details={{
              pwd: userPassword,
              emp_uid: userEmp_uid,
              email: userPersonalEmail,
              phoneNumber: (userCountryCode + userPhoneNumber).split(" ").join(""),
            }}
          />
        )}

        {(nonSSOReqType === "login" || nonSSOReqType === "validate") &&
          (nonSSOStatus === "success" || nonSSOStatus === "fail") && (
            //nonSSOMsg === "" &&
            <OTPVerification
              details={{
                type: nonSSOReqType,
                state: nonSSOState,
                status: nonSSOStatus,
                mail: mail,
                pwd: password,
              }}
            />
          )}

        {authStep === "identifier" && !isForgotPwd && (
        <div className="videoSection mt-4">
          <button
            type="button"
            className="videoChip"
            onClick={() => setVideoModalOpen(true)}
          >
            <span className="pv">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            </span>
            <span className="videoChipText">
              <span className="videoChipTitle">Get to Know TTEC Connect</span>
              <span className="videoChipSub">Watch the 2-minute tour</span>
            </span>
          </button>
        </div>
        )}
        <footer className="authFooter">
          © {currentYear} TTEC, All rights reserved.
        </footer>
      </div>
      <div id="loginWeb">
        <div className="loginFrame">
        <div className="authTopBar">
          <img
            src="./TTEC CONNECT_blueLogo.png"
            className="brandLogo"
            alt="TTEC Connect"
          />
          <div className="authTopActions">
            <a
              className="helpLink"
              href="/docs/TTEConnect Login Process.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faCircleQuestion} />
              <span>Having issues logging in?</span>
            </a>
            <span
              className="notifBtn"
              title="Release Updates"
              role="button"
              tabIndex={0}
              onClick={() => setShowAnnouncement(true)}
            >
              <FontAwesomeIcon icon={faBullhorn} />
            </span>
          </div>
        </div>
        {showAnnouncement && (
          <NewFeatureAnnouncement
            announcements={[]}
            fromHeader={true}
            onClose={() => setShowAnnouncement(false)}
          />
        )}
        {regrequestType === "genOtp" && otpstatus === "200" && userEmp_uid ? (
          <OTPVerification
            details={{
              pwd: userPassword,
              emp_uid: userEmp_uid,
              email: userPersonalEmail,
              phoneNumber: (userCountryCode + userPhoneNumber).split(" ").join(""),
            }}
          />
        ) : (nonSSOReqType === "login" || nonSSOReqType === "validate") &&
          (nonSSOStatus === "success" || nonSSOStatus === "fail") ? (
          // && nonSSOMsg === ""
          <OTPVerification
            details={{
              type: nonSSOReqType,
              state: nonSSOState,
              status: nonSSOStatus,
              mail: mail,
              pwd: password,
            }}
          />
        ) : (
          ((isLogin &&
            nonSSOReqType === "" &&
            nonSSOState !== "fulfilled" &&
            nonSSOStatus !== "success" &&
            regrequestType !== "genOtp") ||
            (!isLogin && otpstatus !== "200")) && (
            <div className="landingPage">
              <aside className="brandPanel" aria-hidden="true">
                <div className="brandGrid" />
                <DotGlobe className="brandGlobe" size={520} variant="bright" />
                <div className="brandPanelContent">
                  <div className="brandCopy">
                    <h2 className="brandTitle">
                      Your first day,
                      <br />
                      <em>already in motion.</em>
                    </h2>
                    <p className="brandTagline">
                      Everything a new hire needs — onboarding and your team —
                      in one place. Sign in to pick up where you left off.
                    </p>
                  </div>
                </div>
              </aside>
              <section className="authField">
              <div className="loginContainer" ref={navRef}>
                {!isForgotPwd && authStep !== "register" && (
                  <>
                    <div className="eyebrow">Welcome</div>
                    <h1 className="authH1">Sign in to TTEC&nbsp;Connect</h1>
                    <p className="sub">
                      {authStep === "identifier"
                        ? "Enter your email and we'll take you to the right sign-in method — no need to choose an account type."
                        : "Welcome back — enter your password to continue."}
                    </p>
                  </>
                )}
                {authStep === "identifier" && !isForgotPwd && (
                  <div className="accordion loginAccordion mt-4">
                    <form
                      className="Auth-form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleContinue();
                      }}
                    >
                      <div className="field">
                        <input
                          id="signinIdEmail"
                          type="email"
                          placeholder=" "
                          value={identifierEmail}
                          onChange={(e) =>
                            setIdentifierEmail(e.currentTarget.value)
                          }
                        />
                        <label htmlFor="signinIdEmail">
                          Email address <span className="req">*</span>
                        </label>
                      </div>
                      <p className="hint">
                        Use the same personal email you provided to TTEC during
                        your application.
                      </p>
                      {identifierError !== "" && (
                        <p className="frmErrors mt-2">{identifierError}</p>
                      )}
                      {classifyState === "fulfilled" &&
                        classifyError === "unrecognized" && (
                          <p className="frmErrors mt-2">
                            We couldn't find an account for that email. Check the
                            address, or create an account.
                          </p>
                        )}
                      {classifyState === "failed" && (
                        <p className="frmErrors mt-2">
                          We couldn't reach the sign-in service. Please try again
                          in a moment.
                        </p>
                      )}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={classifyState === "pending"}
                      >
                        Continue
                      </button>
                    </form>
                    <p className="foot">
                      New to TTEC Connect?{" "}
                      <Link to="" onClick={goToRegister}>
                        Create an account
                      </Link>
                    </p>
                  </div>
                )}
                {authStep === "password" && !isForgotPwd && (
                  <div className="emailChip">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                      <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                    </svg>
                    <span className="emailChipValue">{identifierEmail}</span>
                    <Link to="" onClick={handleChangeIdentifier}>
                      Change
                    </Link>
                  </div>
                )}
                {authStep === "password" && (
                  <div className="accordion loginAccordion mt-4">
                    {!isForgotPwd ? (
                      <form
                        className="Auth-form"
                        onSubmit={signInHandle(handleNonSSOLogin)}
                      >
                        {nonSSOStatus !== "success" &&
                          nonSSOState === "failed" && (
                            <div className="alert otp-fail">{nonSSOMsg}</div>
                          )}
                        <input
                          type="hidden"
                          {...signInRegister("signinEmail")}
                        />
                        <div className="field hasIcon">
                          <input
                            id="signinPassword"
                            type={showLoginPass ? "text" : "password"}
                            placeholder=" "
                            {...signInRegister("password")}
                            onKeyUp={(e) =>
                              setLoginPassword(e.currentTarget.value)
                            }
                          />
                          <label htmlFor="signinPassword">
                            Password <span className="req">*</span>
                          </label>
                          <button
                            type="button"
                            className="icon"
                            aria-label="Show password"
                            onClick={() => setShowLoginPass((s) => !s)}
                          >
                            <svg viewBox="0 0 24 24" fill="none">
                              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="2" />
                              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                            </svg>
                          </button>
                        </div>
                        {signInErrors?.password && (
                          <p className="frmErrors mt-2">
                            {signInErrors.password.message}
                          </p>
                        )}
                        <div className="rowbetween">
                          <Link to="" onClick={handleForgotPassword}>
                            Forgot password?
                          </Link>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={nonSSOState === "pending"}
                        >
                          Sign in
                        </button>
                        <p className="foot">
                          New to TTEC Connect?{" "}
                          <Link to="" onClick={goToRegister}>
                            Create an account
                          </Link>
                        </p>
                      </form>
                    ) : (
                      <form
                        className="Auth-form"
                        onSubmit={forgotPwdHandle(handleForgetPassword)}
                      >
                        <div className="recoveryTopRow">
                          <span className="backlink" onClick={handleBackSignIn}>
                            <svg viewBox="0 0 24 24" fill="none">
                              <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Back to sign in
                          </span>
                          <div className="eyebrow">Account recovery</div>
                        </div>
                        <h1 className="authH1">Reset your password</h1>
                        <p className="sub">
                          Enter your email and we&apos;ll send you a link to set a
                          new password.
                        </p>
                        {!isFirstFPCall &&
                          mailStatus !== "200" &&
                          fpMail !== "" &&
                          (state === "fulfilled" || state === "failed") && (
                            <div className="alert err">
                              Please enter the valid email
                            </div>
                          )}
                        {mailStatus === "200" && (
                          <div className="alert ok">
                            Your password reset email has been sent. If you
                            don&apos;t receive it please wait a few minutes and
                            try again.
                          </div>
                        )}
                        {mailStatus !== "200" &&
                          (identifierEmail ? (
                            <>
                              <input
                                type="hidden"
                                {...forgotPwdRegister("forgotPwdEmail")}
                              />
                              <div className="emailChip">
                                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                                  <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                                </svg>
                                <span className="emailChipValue">
                                  {identifierEmail}
                                </span>
                                <Link to="" onClick={handleChangeIdentifier}>
                                  Change
                                </Link>
                              </div>
                            </>
                          ) : (
                            <div className="field">
                              <input
                                id="fgEmail"
                                type="email"
                                placeholder=" "
                                {...forgotPwdRegister("forgotPwdEmail")}
                                onChange={(event) =>
                                  setfpMail(event.target.value)
                                }
                              />
                              <label htmlFor="fgEmail">
                                Email address <span className="req">*</span>
                              </label>
                            </div>
                          ))}
                        {forgotPwdErrors?.forgotPwdEmail && (
                          <p className="frmErrors mt-2">
                            {forgotPwdErrors.forgotPwdEmail.message}
                          </p>
                        )}
                        {mailStatus !== "200" && (
                          <button
                            type="submit"
                            disabled={state === "pending"}
                            className="btn btn-primary"
                          >
                            Send reset link
                          </button>
                        )}
                      </form>
                    )}
                  </div>
                )}
                {authStep === "register" &&
                  emailStatus !== "200" &&
                  otpstatus !== "200" &&
                  nonSSOReqType === "" &&
                  nonSSOState !== "fulfilled" &&
                  nonSSOStatus !== "success" && (
                    <div className="accordion registerAccordion">
                      <form
                        className="Auth-form-sub"
                        onSubmit={signUpHandle(handleSignUp)}
                      >
                        <span className="backlink" onClick={handleChangeIdentifier}>
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Back to sign in
                        </span>
                        <div className="stepper">
                          <div className="st active">
                            <span className="dot">1</span>Account
                          </div>
                          <span className="bar"></span>
                          <div className="st">
                            <span className="dot">2</span>Verify
                          </div>
                        </div>
                        <h1 className="authH1">Create your account</h1>
                        <p className="sub">
                          Use the same personal email you provided to TTEC during
                          your application.
                        </p>
                        {emailStatus === "302" && otpstate !== "pending" && (
                          <div className="alert err">
                            Invalid or already registered email.
                          </div>
                        )}
                        <div className="field">
                          <input
                            id="rgEmail"
                            type="email"
                            placeholder=" "
                            {...signUpRegister("signUpEmail")}
                            onChange={(event) =>
                              setUserPersonalEmail(event.target.value)
                            }
                          />
                          <label htmlFor="rgEmail">
                            Email address <span className="req">*</span>
                          </label>
                        </div>
                        <p className="frmErrors mt-2">
                          {(emailStatus === "400" &&
                            otpstate !== "pending" &&
                            "Invalid or already registered email.") ||
                            (signUpErrors?.signUpEmail &&
                              signUpErrors.signUpEmail.message)}
                        </p>
                        {emailStatus !== "200" && (
                          <div className="field">
                            <input
                              id="rgEmail2"
                              type="email"
                              placeholder=" "
                              {...signUpRegister("verifyemail")}
                            />
                            <label htmlFor="rgEmail2">
                              Verify email address <span className="req">*</span>
                            </label>
                          </div>
                        )}
                        {signUpErrors?.verifyemail && (
                          <p className="frmErrors mt-2">
                            {signUpErrors.verifyemail.message}
                          </p>
                        )}
                        <div className="field hasIcon">
                          <input
                            id="rgPass"
                            type={showRgPass ? "text" : "password"}
                            placeholder=" "
                            {...signUpRegister("signUpPassword")}
                            onChange={(event) => {
                              setUserPassword(event.target.value);
                              setRgStrength(calcStrength(event.target.value));
                            }}
                          />
                          <label htmlFor="rgPass">
                            Password <span className="req">*</span>
                          </label>
                          <button
                            type="button"
                            className="icon"
                            aria-label="Show password"
                            onClick={() => setShowRgPass((s) => !s)}
                          >
                            <svg viewBox="0 0 24 24" fill="none">
                              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="2" />
                              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                            </svg>
                          </button>
                        </div>
                        <div className="meter">
                          {[1, 2, 3, 4].map((n) => (
                            <i
                              key={n}
                              className={n <= rgStrength ? "on" + rgStrength : ""}
                            />
                          ))}
                        </div>
                        <div className="meter-label">
                          <span>8+ chars · upper · lower · number · symbol</span>
                          <span>
                            {["", "Weak", "Fair", "Good", "Strong"][rgStrength]}
                          </span>
                        </div>
                        {signUpErrors?.signUpPassword && (
                          <p className="frmErrors mt-2">
                            {signUpErrors.signUpPassword.message}
                          </p>
                        )}
                        <div className="field">
                          <input
                            id="rgPass2"
                            type="password"
                            placeholder=" "
                            {...signUpRegister("verifypassword")}
                          />
                          <label htmlFor="rgPass2">
                            Verify password <span className="req">*</span>
                          </label>
                        </div>
                        {signUpErrors?.verifypassword && (
                          <p className="frmErrors mt-2">
                            {signUpErrors.verifypassword.message}
                          </p>
                        )}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "130px 1fr",
                            gap: "11px",
                          }}
                        >
                          <div className="field">
                              <select
                                id="rgCc"
                                className="filled"
                                {...signUpRegister("countryCode")}
                                onChange={(event) =>
                                  setUserCountryCode(event.target.value)
                                }
                              >
                                <option value=""></option>
                                <option value="+376">AD (+376)</option>
                                <option value="+971">AE (+971)</option>
                                <option value="+1268">AG (+1268)</option>
                                <option value="+1264">AI (+1264)</option>
                                <option value="+374">AM (+374)</option>
                                <option value="+244">AO (+244)</option>
                                <option value="+54">AR (+54)</option>
                                <option value="+43">AT (+43)</option>
                                <option value="+61">AU (+61)</option>
                                <option value="+297">AW (+297)</option>
                                <option value="+994">AZ (+994)</option>
                                <option value="+387">BA (+387)</option>
                                <option value="+1246">BB (+1246)</option>
                                <option value="+880">BD (+880)</option>
                                <option value="+32">BE (+32)</option>
                                <option value="+226">BF (+226)</option>
                                <option value="+359">BG (+359)</option>
                                <option value="+973">BH (+973)</option>
                                <option value="+257">BI (+257)</option>
                                <option value="+229">BJ (+229)</option>
                                <option value="+1441">BM (+1441)</option>
                                <option value="+673">BN (+673)</option>
                                <option value="+591">BO (+591)</option>
                                <option value="+55">BR (+55)</option>
                                <option value="+1242">BS (+1242)</option>
                                <option value="+975">BT (+975)</option>
                                <option value="+267">BW (+267)</option>
                                <option value="+375">BY (+375)</option>
                                <option value="+501">BZ (+501)</option>
                                <option value="+1">CA (+1)</option>
                                <option value="+236">CF (+236)</option>
                                <option value="+242">CG (+242)</option>
                                <option value="+41">CH (+41)</option>
                                <option value="+682">CK (+682)</option>
                                <option value="+56">CL (+56)</option>
                                <option value="+237">CM (+237)</option>
                                <option value="+86">CN (+86)</option>
                                <option value="+57">CO (+57)</option>
                                <option value="+506">CR (+506)</option>
                                <option value="+381">CS (+381)</option>
                                <option value="+53">CU (+53)</option>
                                <option value="+238">CV (+238)</option>
                                <option value="+357">CY (+357)</option>
                                <option value="+9039">CY (+9039)</option>
                                <option value="+42">CZ (+42)</option>
                                <option value="+49">DE (+49)</option>
                                <option value="+253">DJ (+253)</option>
                                <option value="+45">DK (+45)</option>
                                <option value="+1809">DM (+1809)</option>
                                <option value="+1809">DO (+1809)</option>
                                <option value="+213">DZ (+213)</option>
                                <option value="+593">EC (+593)</option>
                                <option value="+372">EE (+372)</option>
                                <option value="+20">EG (+20)</option>
                                <option value="+291">ER (+291)</option>
                                <option value="+34">ES (+34)</option>
                                <option value="+251">ET (+251)</option>
                                <option value="+358">FI (+358)</option>
                                <option value="+679">FJ (+679)</option>
                                <option value="+500">FK (+500)</option>
                                <option value="+691">FM (+691)</option>
                                <option value="+298">FO (+298)</option>
                                <option value="+33">FR (+33)</option>
                                <option value="+241">GA (+241)</option>
                                <option value="+44">GB (+44)</option>
                                <option value="+1473">GD (+1473)</option>
                                <option value="+7880">GE (+7880)</option>
                                <option value="+594">GF (+594)</option>
                                <option value="+233">GH (+233)</option>
                                <option value="+350">GI (+350)</option>
                                <option value="+299">GL (+299)</option>
                                <option value="+220">GM (+220)</option>
                                <option value="+224">GN (+224)</option>
                                <option value="+590">GP (+590)</option>
                                <option value="+240">GQ (+240)</option>
                                <option value="+30">GR (+30)</option>
                                <option value="+502">GT (+502)</option>
                                <option value="+671">GU (+671)</option>
                                <option value="+245">GW (+245)</option>
                                <option value="+592">GY (+592)</option>
                                <option value="+852">HK (+852)</option>
                                <option value="+504">HN (+504)</option>
                                <option value="+385">HR (+385)</option>
                                <option value="+509">HT (+509)</option>
                                <option value="+36">HU (+36)</option>
                                <option value="+62">ID (+62)</option>
                                <option value="+353">IE (+353)</option>
                                <option value="+972">IL (+972)</option>
                                <option value="+91">IN (+91)</option>
                                <option value="+964">IQ (+964)</option>
                                <option value="+98">IR (+98)</option>
                                <option value="+354">IS (+354)</option>
                                <option value="+39">IT (+39)</option>
                                <option value="+1876">JM (+1876)</option>
                                <option value="+962">JO (+962)</option>
                                <option value="+81">JP (+81)</option>
                                <option value="+254">KE (+254)</option>
                                <option value="+996">KG (+996)</option>
                                <option value="+855">KH (+855)</option>
                                <option value="+686">KI (+686)</option>
                                <option value="+269">KM (+269)</option>
                                <option value="+1869">KN (+1869)</option>
                                <option value="+850">KP (+850)</option>
                                <option value="+82">KR (+82)</option>
                                <option value="+965">KW (+965)</option>
                                <option value="+1345">KY (+1345)</option>
                                <option value="+7">KZ (+7)</option>
                                <option value="+856">LA (+856)</option>
                                <option value="+961">LB (+961)</option>
                                <option value="+417">LI (+417)</option>
                                <option value="+94">LK (+94)</option>
                                <option value="+231">LR (+231)</option>
                                <option value="+266">LS (+266)</option>
                                <option value="+370">LT (+370)</option>
                                <option value="+352">LU (+352)</option>
                                <option value="+371">LV (+371)</option>
                                <option value="+218">LY (+218)</option>
                                <option value="+212">MA (+212)</option>
                                <option value="+377">MC (+377)</option>
                                <option value="+373">MD (+373)</option>
                                <option value="+261">MG (+261)</option>
                                <option value="+692">MH (+692)</option>
                                <option value="+389">MK (+389)</option>
                                <option value="+223">ML (+223)</option>
                                <option value="+95">MN (+95)</option>
                                <option value="+976">MN (+976)</option>
                                <option value="+853">MO (+853)</option>
                                <option value="+596">MQ (+596)</option>
                                <option value="+222">MR (+222)</option>
                                <option value="+1664">MS (+1664)</option>
                                <option value="+356">MT (+356)</option>
                                <option value="+960">MV (+960)</option>
                                <option value="+265">MW (+265)</option>
                                <option value="+52">MX (+52)</option>
                                <option value="+60">MY (+60)</option>
                                <option value="+258">MZ (+258)</option>
                                <option value="+264">NA (+264)</option>
                                <option value="+687">NC (+687)</option>
                                <option value="+227">NE (+227)</option>
                                <option value="+672">NF (+672)</option>
                                <option value="+234">NG (+234)</option>
                                <option value="+505">NI (+505)</option>
                                <option value="+31">NL (+31)</option>
                                <option value="+47">NO (+47)</option>
                                <option value="+670">NP (+670)</option>
                                <option value="+977">NP (+977)</option>
                                <option value="+674">NR (+674)</option>
                                <option value="+683">NU (+683)</option>
                                <option value="+64">NZ (+64)</option>
                                <option value="+968">OM (+968)</option>
                                <option value="+507">PA (+507)</option>
                                <option value="+51">PE (+51)</option>
                                <option value="+689">PF (+689)</option>
                                <option value="+675">PG (+675)</option>
                                <option value="+63">PH (+63)</option>
                                <option value="+48">PL (+48)</option>
                                <option value="+1787">PR (+1787)</option>
                                <option value="+351">PT (+351)</option>
                                <option value="+680">PW (+680)</option>
                                <option value="+595">PY (+595)</option>
                                <option value="+974">QA (+974)</option>
                                <option value="+262">RE (+262)</option>
                                <option value="+40">RO (+40)</option>
                                <option value="+7">RU (+7)</option>
                                <option value="+250">RW (+250)</option>
                                <option value="+966">SA (+966)</option>
                                <option value="+677">SB (+677)</option>
                                <option value="+1758">SC (+1758)</option>
                                <option value="+248">SC (+248)</option>
                                <option value="+249">SD (+249)</option>
                                <option value="+46">SE (+46)</option>
                                <option value="+65">SG (+65)</option>
                                <option value="+290">SH (+290)</option>
                                <option value="+386">SI (+386)</option>
                                <option value="+963">SI (+963)</option>
                                <option value="+421">SK (+421)</option>
                                <option value="+232">SL (+232)</option>
                                <option value="+378">SM (+378)</option>
                                <option value="+221">SN (+221)</option>
                                <option value="+252">SO (+252)</option>
                                <option value="+597">SR (+597)</option>
                                <option value="+239">ST (+239)</option>
                                <option value="+503">SV (+503)</option>
                                <option value="+268">SZ (+268)</option>
                                <option value="+1649">TC (+1649)</option>
                                <option value="+228">TG (+228)</option>
                                <option value="+66">TH (+66)</option>
                                <option value="+7">TJ (+7)</option>
                                <option value="+7">TM (+7)</option>
                                <option value="+993">TM (+993)</option>
                                <option value="+216">TN (+216)</option>
                                <option value="+676">TO (+676)</option>
                                <option value="+90">TR (+90)</option>
                                <option value="+1868">TT (+1868)</option>
                                <option value="+688">TV (+688)</option>
                                <option value="+886">TW (+886)</option>
                                <option value="+380">UA (+380)</option>
                                <option value="+256">UG (+256)</option>
                                <option value="+1">US (+1)</option>
                                <option value="+598">UY (+598)</option>
                                <option value="+7">UZ (+7)</option>
                                <option value="+379">VA (+379)</option>
                                <option value="+58">VE (+58)</option>
                                <option value="+1284">VG (+1284)</option>
                                <option value="+1340">VI (+1340)</option>
                                <option value="+84">VN (+84)</option>
                                <option value="+678">VU (+678)</option>
                                <option value="+681">WF (+681)</option>
                                <option value="+967">YE (+967)</option>
                                <option value="+969">YE (+969)</option>
                                <option value="+269">YT (+269)</option>
                                <option value="+27">ZA (+27)</option>
                                <option value="+260">ZM (+260)</option>
                                <option value="+263">ZW (+263)</option>
                              </select>
                              <label htmlFor="rgCc">
                                Code <span className="req">*</span>
                              </label>
                          </div>
                          <div className="field">
                            <input
                              id="rgPhone"
                              type="tel"
                              placeholder=" "
                              {...signUpRegister("mobileNumber")}
                              onChange={(event) =>
                                setUserPhoneNumber(event.target.value)
                              }
                              onInput={(e) =>
                              (e.currentTarget.value =
                                e.currentTarget.value.slice(0, 15))
                              }
                            />
                            <label htmlFor="rgPhone">
                              Phone number <span className="req">*</span>
                            </label>
                          </div>
                        </div>
                        <p className="hint">
                          We&apos;ll text a 6-digit verification code to this
                          number.
                        </p>
                        {signUpErrors?.countryCode && (
                          <p className="frmErrors mt-2">
                            {signUpErrors.countryCode.message}
                          </p>
                        )}
                        {signUpErrors?.mobileNumber && (
                          <p className="frmErrors mt-2">
                            {signUpErrors.mobileNumber.message}
                          </p>
                        )}
                        {emailStatus !== "200" && (
                          <button
                            type="submit"
                            disabled={otpstate === "pending"}
                            className="btn btn-primary"
                          >
                            Create account
                          </button>
                        )}
                      </form>
                    </div>
                  )}
                {authStep === "identifier" && !isForgotPwd && (
                <div className="videoSection mt-4">
                  <button
                    type="button"
                    className="videoChip"
                    onClick={() => setVideoModalOpen(true)}
                  >
                    <span className="pv">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </span>
                    <span className="videoChipText">
                      <span className="videoChipTitle">Get to Know TTEC Connect</span>
                      <span className="videoChipSub">Watch the 2-minute tour</span>
                    </span>
                  </button>
                </div>
                )}
              </div>
              </section>
            </div>
          )
        )}
        </div>
        <footer className="authFooter">
          © {currentYear} TTEC, All rights reserved.
        </footer>
      </div>
    </>
  );
};

export default Login;
